export enum SortOptions {
    Newest = 'naujausi',
    Oldest = 'seniausi',
}

export type PaginationQuery = { currentPage: number; pageSize: number; sort: `${SortOptions}` };
